export default class ApiBase {
    public endpoint: string

    constructor(endpoint: string) {
        this.endpoint = endpoint
    }
}
